import { ReactNode } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { catchAll } from '@sorare/routing';

import {
  FOOTBALL_MARKET_MANAGER_SALES,
  MLB_MARKET_SECONDARY,
  NBA_MARKET_SECONDARY,
} from '@sorare/core/src/constants/__generated__/routes';
import useFeatureFlags from '@sorare/core/src/hooks/useFeatureFlags';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';

import { DisabledMarket } from './DisabledMarket';

const MarketRootContainer = styled.div`
  background-color: var(--c-neutral-100);
  color: var(--c-neutral-1000);
`;

export const MarketRoot = ({ children }: { children: ReactNode }) => {
  const location = useLocation();
  const { isAndroidApp } = useIsMobileApp();
  const {
    flags: { buyOnWebMarketplaceFromAndroid = false },
  } = useFeatureFlags();

  const secondaryMarket =
    matchPath(catchAll(FOOTBALL_MARKET_MANAGER_SALES), location.pathname) ||
    matchPath(catchAll(NBA_MARKET_SECONDARY), location.pathname) ||
    matchPath(catchAll(MLB_MARKET_SECONDARY), location.pathname);

  if (isAndroidApp && buyOnWebMarketplaceFromAndroid && secondaryMarket) {
    return <DisabledMarket />;
  }

  return <MarketRootContainer>{children}</MarketRootContainer>;
};
